var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTodo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 6,
    fill: "#FCCCCF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1533 19.5C14.0361 19.7021 13.8679 19.8698 13.6655 19.9864C13.4631 20.103 13.2336 20.1643 13 20.1643C12.7664 20.1643 12.5369 20.103 12.3345 19.9864C12.1321 19.8698 11.9639 19.7021 11.8467 19.5M17 10.8334C17 9.77251 16.5786 8.75509 15.8284 8.00495C15.0783 7.2548 14.0609 6.83337 13 6.83337C11.9391 6.83337 10.9217 7.2548 10.1716 8.00495C9.42143 8.75509 9 9.77251 9 10.8334C9 15.5 7 16.8334 7 16.8334H19C19 16.8334 17 15.5 17 10.8334Z",
    stroke: "#F55B64",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodo);
export default __webpack_public_path__ + "static/media/todo.e86c9d8f3f709c6672ad06b0e5668497.svg";
export { ForwardRef as ReactComponent };